import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import { orderSummaryStages } from "../../constants/orderSummary";
import { dropdownTitle, dropDownStyle } from "./orderDetailsStyles";
import CustomDropdown from "../../common/CustomDropdown";

type UpdateOptionsProps = {
  currentStage: number;
  setCurrentStage: (val: number) => void;
  disabled?: boolean;
};

export const UpdateOptions: FC<UpdateOptionsProps> = ({
  currentStage,
  setCurrentStage,
  disabled = false,
}) => {
  const options = orderSummaryStages.slice(1).map((item, idx) => ({
    value: idx + 1,
    label: (
      <Box display="flex" alignItems="center" gap="8px">
        <img src={item.icon} alt={`${item.title}-icon`} />
        {item.title}
      </Box>
    ),
    icon: item.icon,
  }));

  return (
    <Box sx={{ flexDirection: "row", marginLeft: "16px" }}>
      <Typography sx={{ ...dropdownTitle, fontSize: "20px" }}>
        Update Order Status
      </Typography>
      <Box
        sx={{
          ...dropDownStyle,
          width: "302px",
          ...(disabled && { pointerEvents: "none", opacity: 0.6 }),
        }}
      >
        <CustomDropdown
          label="Select Status"
          value={currentStage.toString()}
          options={options.map((opt) => ({
            value: opt.value.toString(),
            label: opt.label,
          }))}
          onChange={(selectedValue) => {
            if (disabled) return;
            setCurrentStage(Number(selectedValue));
          }}
          menuPlacement="above"
          customStyles={{
            button: {
              borderRadius: "8px",
              ...(disabled && { cursor: "not-allowed" }),
            },
          }}
        />
      </Box>
    </Box>
  );
};
